import { useEffect, useState } from "react"
import { SelectDropdown } from "@prosolve/common-components-ui"
import AccountDropdown from "../Shared/AccountDropdown"
import useOrderType from "../Shared/useOrderType"
import OptionalFormFieldWrapper from "../Shared/OptionalFormFieldWrapper"

export default ({
  orders: defaultOrders,
  onFilteredOrdersChange
}) => {
  const [account, setAccount] = useState()
  const [orderType, setOrderType] = useState()
  const [draftStatus, setDraftStatus] = useState()
  const [orderStatus, setOrderStatus] = useState()
  const [shipmentType, setShipmentType] = useState()
  const [carrierType, setCarrierType] = useState()

  const [orders, setOrders] = useState(defaultOrders)

  const filters = useOrderType()

  const updateFilteredOrders = () => {
    const filteredOrders = orders.filter(o => {
      if (account && account !== '[noaccount]' && o.data?.accountId !== account) return false
      if (account === '[noaccount]' && o.data?.accountId) return false
      if (draftStatus && draftStatus !== 'All' && (o.dataSb?.status_derived || o.data?.status || '')?.toLowerCase() !== draftStatus?.toLowerCase()) return false
      if (orderType === 'draft' && o.dataSb) return false
      if (orderStatus && orderStatus !== 'All' && (o.dataSb?.status_derived || '')?.toLowerCase() !== orderStatus?.toLowerCase()) return false
      if (orderType === 'shipbob' && !o.dataSb) return false
      if (shipmentType && (o.dataSb?.type || o.data?.shippingType)?.toLowerCase() !== shipmentType?.toLowerCase()) return false
      if (carrierType && (o.dataSb?.shipping_terms?.carrier_type || o.data?.carrierType)?.toLowerCase() !== carrierType?.toLowerCase()) return false
      return true
    }).slice(0, 100)
    onFilteredOrdersChange(filteredOrders)
  }

  useEffect(() => {
    setOrders(defaultOrders)
  }, [defaultOrders])

  useEffect(() => {
    updateFilteredOrders()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders, account, orderType, draftStatus, orderStatus, shipmentType, carrierType])

  return (
    <>
      <div style={{ paddingBottom: '10px' }}>
        <AccountDropdown onChange={setAccount} isShowNoAccountOption={true} />
      </div>
      
      <div style={{ display: 'flex', gap: '10px', paddingBottom: '20px', positive: 'relative' }}>
        <OptionalFormFieldWrapper isEnabled={true} label={'Order Type'}>
          <SelectDropdown
            width={'180px'}
            options={filters.orderTypes}
            onChange={setOrderType}
          />
        </OptionalFormFieldWrapper>

        <OptionalFormFieldWrapper isEnabled={true} label={'Draft Status'}>
          <SelectDropdown
            width={'180px'}
            options={filters.draftStatuses}
            onChange={setDraftStatus}
          />
        </OptionalFormFieldWrapper>
        
        <OptionalFormFieldWrapper isEnabled={true} label={'Shipbob Status'}>
          <SelectDropdown
            width={'180px'}
            options={filters.orderStatuses}
            onChange={setOrderStatus}
          />
        </OptionalFormFieldWrapper>
        
        <OptionalFormFieldWrapper isEnabled={true} label={'Shipment Type'}>
          <SelectDropdown
            width={'240px'}
            options={filters.shipmentType}
            onChange={setShipmentType}
          />
        </OptionalFormFieldWrapper>
        
        <OptionalFormFieldWrapper isEnabled={true} label={'Carrier Type'}>
          <SelectDropdown
            width={'120px'}
            options={filters.carrierType}
            onChange={setCarrierType}
          />
        </OptionalFormFieldWrapper>
      </div>
    </>
  )
}